<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5">{{!selectExento  ? 'Agregar' : 'Editar'}} RNTs exentos de aprobación automática</label>
      </header>

      <!-- formularios para registrar y actualizar -->
      <form [formGroup]="formExentos" (ngSubmit)="onOperarParametroExento()">
        <div class="form-group">
          <label class="small text-secondary" for="nit">Codigo RNT</label>
          <input id="codigo_rnt" formControlName="codigo_rnt" type="text" class="form-control form-control-sm"  (blur)=" onObtenerRNTexento()"  >
        </div>
        <div class="form-group">
          <div class="form-group" *ngIf="authService.getRolUser(soloConsultaNacional)">
          <label class="small text-secondary" for="nit">Cámara de Comercio</label>
          <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara" (change)="onDepartamentosSelect()" >
            <option class="" value="null" selected="true">
              Seleccione
            </option>
            <option class="" *ngFor="let option of camarasLista; let i = index"
              value="{{option?.codigo_camara}}" [selected]="false">
              {{option?.desc_camara}}
            </option>
          </select>
        </div>
        </div>
          <div class="form-group">
            <label class="small text-secondary" for="razon_social">Nombre o Razón social</label>
            <input id="razon_social" formControlName="razon_social" type="text" class="form-control form-control-sm">
         </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">NIT</label>
          <input id="nit" formControlName="nit" type="text" class="form-control form-control-sm">
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Categoría</label>
          <select class="form-control form-control-sm" id="categoria" formControlName="categoria"  (change)="onSubcategoriaSelect()" >
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" *ngFor="let option of categoria; let i = index"
              value="{{option?.categoria_id}}" [selected]="false">
              {{option?.descripcion}}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="sub_categoria">Subcategoría</label>
          <select class="form-control form-control-sm" id="sub_categoria" formControlName="sub_categoria">
            <option class="" value="" selected="true">
              Seleccione
            </option>
            <option class="" *ngFor="let option of subcategoria; let i = index"
              value="{{option?.sub_categoria_id}}" [selected]="false">
              {{option?.descripcion}}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="codigo_departamento">Departamento</label>
          <select class="form-control form-control-sm" id="codigo_departamento" formControlName="codigo_departamento" (change)="onMunicipioSelect()">
             <option class="" value="" selected="true">
                 Seleccione
              </option>
             <option class="" *ngFor="let option of departamento; let i = index"
                 value="{{option?.departamento_id}}" [selected]="false">
                 {{option?.descripcion}}
             </option>
          </select>
       </div>
       <div class="form-group">
           <label class="small text-secondary" for="municipio_id">Municipio</label>
           <select class="form-control form-control-sm" id="municipio_id" formControlName="municipio_id">
              <option class="" value="" selected="true">
                  Seleccione
               </option>
              <option class="" *ngFor="let option of municipio; let i = index"
                  value="{{option?.municipio_id}}" [selected]="false">
                  {{option?.descripcion}}
              </option>
           </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Justificación de la excepción</label>
          <textarea id="descripcion_excepcion" formControlName="descripcion_excepcion"  class="form-control form-control-sm"></textarea>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Fecha hasta que aplica la excepcion</label>
          <input id="fecha_excepcion" formControlName="fecha_excepcion" type="datetime-local" class="form-control form-control-sm">
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Estado</label>
          <select class="form-control form-control-sm" id="activo" formControlName="activo"
            [attr.disabled]="!selectExento ? '' : null">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="true">
              Activo
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              Inactivo
            </option>
          </select>
        </div>
        <div class="form-row mt-5">
          <button type="button" class="btn btn-outline-primary border-0 m-auto"
            (click)="limpiarCampo()">Limpiar</button>
          <button class="btn btn-primary m-auto " [disabled]="!formExentos.valid" type="submit">{{!selectExento
            ? 'Agregar' : 'Editar'}}</button>
        </div>
      </form>
    </section>


    <section class="col-9 p-4 mt-5 mb-5">
      <div class="d-flex justify-content-between">
        <div>
          <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
          <label class="h5">Listado de RNTs exentos de aprobación automática</label>
        </div>
        <p>
          <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </p>
      </div>


      <!-- formulario para aplicar filtro -->
      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="formfiltro" (submit)="filtrar()">
              <div class="row">
                <!-- Cámara de comercio (Lista de múltiple selección) -->
                <div class="col-4 form-group">
                  <div class="form-group" *ngIf="authService.getRolUser(soloConsultaNacional)">
                  <label class="small text-secondary" for="codigo_camara">Cámara de Comercio</label>
                  <select id="codigo_camara" formControlName="codigo_camara"  class="form-control form-control-sm" (change)="onDepartamentosSelectFiltro()">
                    <option class="" value="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let camara of camarasListafil; let i = index"
                      value="{{camara?.codigo_camara}}" [selected]="false">
                      {{camara?.desc_camara}}
                    </option>
                  </select>
                  </div>
                </div>

                <!-- Número RNT -->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="numeroRNT">Número RNT</label>
                  <input id="numeroRNT" formControlName="numeroRNT" type="text" class="form-control form-control-sm">
                </div>

                <!-- Nit -->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Nit</label>
                  <input id="nit" formControlName="nit" type="text" class="form-control form-control-sm">
                </div>

                <!-- Razón Social o Nombre -->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="razonSocial">Razón Social o Nombre</label>
                  <input id="razonSocial" formControlName="razonSocial" type="text" class="form-control form-control-sm">
                </div>

                <!-- Categoría (Lista de múltiple selección) -->
                <div class="col-4 form-group">
                  <label class="small text-secondary" for="categoria">Categoría</label>
                  <select id="categoria" formControlName="categoria"  class="form-control form-control-sm" (change)="onSubcategoriaSelectFiltro()"  >
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let categoria of categoriafil; let i = index"
                      value="{{categoria?.categoria_id}}" [selected]="false">
                      {{categoria?.descripcion}}
                    </option>
                  </select>
                </div>

                <!-- Subcategoría (Lista de múltiple selección) -->
                <div class="col-4 form-group">
                  <label class="small text-secondary" for="subcategoria">Subcategoría</label>
                  <select id="subcategoria" formControlName="subcategoria"  class="form-control form-control-sm">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let subcategoria of subcategoriafil; let i = index"
                      value="{{subcategoria?.sub_categoria_id}}" [selected]="false">
                      {{subcategoria?.descripcion}}
                    </option>
                  </select>
                </div>

                <!-- Departamento Comercial (Lista de múltiple selección) -->
                <div class="col-4 form-group">
                  <label class="small text-secondary" for="departamentoComercial">Departamento Comercial</label>
                  <select id="departamentoComercial" formControlName="departamentoComercial"  class="form-control form-control-sm" (change)="onMunicipioSelectFiltro()" >
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let depto of departamentofil; let i = index"
                      value="{{depto?.departamento_id}}" [selected]="false">
                      {{depto?.descripcion}}
                    </option>
                  </select>
                </div>

                <!-- Municipio Comercial (Lista de múltiple selección) -->
                <div class="col-4 form-group">
                  <label class="small text-secondary" for="municipioComercial">Municipio Comercial</label>
                  <select id="municipioComercial" formControlName="municipioComercial"  class="form-control form-control-sm">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let municipio of municipiofil; let i = index"
                      value="{{municipio?.municipio_id}}" [selected]="false">
                      {{municipio?.descripcion}}
                    </option>
                  </select>
                </div>
                <!-- Botones de Filtrar y Limpiar -->
                <div class="d-flex flex-row">
                  <button type="reset" class="btn btn-outline-primary border-0 m-auto" (click)="Resetear()">Limpiar</button>
                  <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">Filtrar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <app-tablas [page] = "paginaActual" [headers]="headerTablaExentos" [sizeData]="dataTabla.paging.totalItems" (paginado)="onPaginado($event)"
          class="table-responsive">
          <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
            <td>{{item.codigo_rnt}}</td>
            <td>{{item.camara}}</td>
            <td>{{item.razon_social}}</td>
            <td>{{item.nit}}</td>
            <td>{{item.categoria}}</td>
            <td>{{item.sub_categoria}}</td>
            <td>{{item.dpto_comercial}}</td>
            <td>{{item.municipio_comercial}}</td>
            <td>{{item.descripcion_excepcion}}</td>
            <td>{{item.usuario_quien_creo}}</td>
            <td>{{item.fecha_aplica_excepcion  | date:'dd-MM-yyyy'}}</td>
            <td>{{item.fin_fecha_aplica_excepcion  | date:'dd-MM-yyyy'}}</td>
            <td>{{item.usuario_ultimo_actualizo}}</td>
            <td>{{item.fecha_ultima_actualizacion  | date:'dd-MM-yyyy'}}</td>
            <td>{{item.activo ? 'Activo' : 'Inactivo'}}</td>
            <td class="d-flex flex-row">
              <img src="../../../../../../../assets/icons/edit.png" class="pointer" alt="" height="25"
                (click)="onCargarRntExentoAEstudio(item)">
            </td>
          </tr>
        </app-tablas>
      </div>
    </section>
  </article>
</main>
